import { IUserInfoDto } from "@kuika/kuika-cl-model";
import _ from "lodash";

declare let window: any;

export interface IWithContextProp {
  context: KContext;
}

export const withContext = <P extends object>(Component: any) => {
  return (props: P) => {
    const context = new KContext();
    return <Component {...props} context={context} />;
  };
};

export class KContext {
  isMasterScreenActive: boolean = true;

  userInfo: IUserInfoDto;

  profilePhoto: string = "";

  constructor() {
    const { userInfo, profilePhoto } = window;
    this.profilePhoto = userInfo?.profilePhoto || profilePhoto;
    this.userInfo = userInfo;
  }

  setClipboardValue = (key: string, value: any) => {
    if (!window.kuika) {
      window.kuika = {};
    }
    if (!window.kuika.clipboard) {
      window.kuika.clipboard = {};
    }
    window.kuika.clipboard[key] = _.cloneDeep(value);
  };

  getClipboardValue = (key: string): any | undefined => {
    let result = "";
    if (window?.kuika?.clipboard !== undefined && window.kuika.clipboard[key] !== undefined) {
      result = window.kuika.clipboard[key];
    }
    return result;
  };

  setUserInfo = (userInfo: IUserInfoDto) => {
    this.userInfo = userInfo;
  };

  setProfilePhoto = (profilePhoto: string) => {
    this.profilePhoto = profilePhoto;
  };
}
